module.exports = __webpack_public_path__ + "media/src/images/referrals-77bbde840438e98527a33075aa7aa302.jpg";